import cx from "classnames";
import { type ComponentProps, forwardRef } from "react";

import { useSidebar } from "./useSidebar";

export const SidebarHeader = forwardRef<HTMLDivElement, ComponentProps<"div">>(
  ({ className, ...props }, ref) => {
    const { open } = useSidebar();

    return (
      <div
        ref={ref}
        data-sidebar="header"
        className={cx(
          "flex h-14 items-center border-b border-b-puntt-neutral-gray-6 transition-all",
          { "px-4": open, "justify-center px-3": !open },
          className,
        )}
        {...props}
      />
    );
  },
);
SidebarHeader.displayName = "SidebarHeader";
